import * as constants from './constants'
import { EditableVariablesCommunity, Community } from 'types/community'
import { storage, storageRef, storageUploadBytes } from 'firebaseConfig/clientApp'
import { EntryType, getDownloadLink } from './general'
import { optionsMaker } from 'helpers/fetchOptions'
import { AppDispatch, RootState } from 'reducers/store'
import { isDev } from 'app/general'

const BASE_DOMAIN = process.env.API

const createImageCommunity = async (dispatch: any, getState: any, imagePath: string, community: Community) => {
  const imageURL = await getDownloadLink(imagePath, dispatch)
  if (!imageURL) {
     isDev && console.log("Can't get download link")
    return
  }

  dispatch({ type: constants.CREATE_IMAGE_COMMUNITY_TRY })

  const accessToken = getState().userReducer.token
  community.image = imageURL
  community.imagePath = imagePath

  // const options = {
  //   method: 'Post',
  //   body: JSON.stringify({
  //     community
  //   }),
  //   headers: {
  //     Authorization: 'Bearer ' + accessToken,
  //     'Content-Type': 'application/json',
  //   },
  // }

  const options = await optionsMaker('Post', { community }, getState, dispatch)
  if (!options) {
    dispatch({ type: constants.CREATE_IMAGE_COMMUNITY_ERROR, error: "no options" })
    return
  }
  try {
    const res = await fetch(`${BASE_DOMAIN}/community`, options)
    const response = await res.json()
    dispatch({
      type: constants.CREATE_IMAGE_COMMUNITY_RESPONSE,
      response: response,
      imageURL,
    })
    if (response.success) {
      dispatch({ type: constants.GO_TO_PAGE, page: '/community/?eid=' + response.entry.id })
    }
  } catch (error) {
    //  isDev && console.log(error)
    dispatch({ type: constants.CREATE_IMAGE_COMMUNITY_ERROR, error: error })
  }
}


// export const uploadImagePost = (community: Community, imageToUpload: any) => {
//   return async (dispatch: AppDispatch, getState: () => RootState) => {
//     dispatch({ type: constants.UPLOAD_IMAGE_POST_TRY })
//     const uid = getState().userReducer.user?.uid

//     const imagePath = 'posts/' + uid + "/" + new Date().getTime();
//     const imageRef = storageRef(storage, imagePath)

//     return await storageUploadBytes(imageRef, imageToUpload)
//       .then((snapshot: any) => {
//         dispatch({
//           type: constants.UPLOAD_IMAGE_POST_RESPONSE,
//           response: snapshot,
//         })
//         createImagePost(dispatch, getState, imagePath, post)
//         return true
//       })
//       .catch((error: any) => {
//         //  isDev && console.log(error)
//         dispatch({ type: constants.UPLOAD_IMAGE_POST_ERROR, error: error })
//         return null
//       })
//   }
// }


export const createCommunity = (community: Community, imageToUpload: any) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.UPLOAD_IMAGE_COMMUNITY_TRY })
    const uid = getState().userReducer.user?.uid

    const imagePath = 'Communities/' + uid + "/" + new Date().getTime();
    const imageRef = storageRef(storage, imagePath)

    return await storageUploadBytes(imageRef, imageToUpload)
      .then((snapshot: any) => {
        dispatch({
          type: constants.UPLOAD_IMAGE_COMMUNITY_RESPONSE,
          response: snapshot,
        })
        createImageCommunity(dispatch, getState, imagePath, community).then(() => {
          return true
        })
      })
      .catch((error: any) => {
        //  isDev && console.log(error)
        dispatch({ type: constants.UPLOAD_IMAGE_COMMUNITY_ERROR, error: error })
        return null
      })
  }
}


// return async (dispatch: AppDispatch, getState: () => RootState) => {
//   dispatch({ type: constants.CREATE_COMMUNITY_TRY })

//   const accessToken = getState().userReducer.token;
//   const options = await optionsMaker('Post', { community }, getState, dispatch)
//   if (!options) return
//   try {
//     const res = await fetch(`${BASE_DOMAIN}/community`, options)

//     const response = await res.json()
//     if (response.success) {
//       //UPLOAD IMAGE to FIRESTORE
//       const imageName = response.imageName
//       const entryId = response.communityId

//       const isUploadImage = await uploadImageToCommunity('communities/' + entryId + '/' + imageName, imageToUpload, dispatch,)
//       if (isUploadImage) {
//         await addDownloadImageToBackend(entryId, imageName, dispatch, accessToken)
//         dispatch({ type: constants.GO_TO_PAGE, page: '/community?eid=' + entryId })
//       }
//     }
//     dispatch({
//       type: constants.CREATE_COMMUNITY_RESPONSE,
//       response: response,
//     })

//     // if (response.success)
//     //   dispatch({ type: constants.GO_TO_PAGE, page: '/community?eid' + response.CommunityId })


//   } catch (error) {
//     dispatch({ type: constants.CREATE_COMMUNITY_ERROR, error: error })
//   }
// }
// }

export const updateCommunity = (communityId: string, community: EditableVariablesCommunity) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.EDIT_COMMUNITY_TRY })
    const accessToken = getState().userReducer.token
    // const options = {
    //   method: 'Patch',
    //   body: JSON.stringify({ community }),
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('PATCH', { community }, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.EDIT_COMMUNITY_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(BASE_DOMAIN + '/community/' + communityId, options)
      const response = await res.json()

      dispatch({
        type: constants.EDIT_COMMUNITY_RESPONSE,
        response: response,
      })

      if (response.success) {
        dispatch(getCommunity(communityId))
        dispatch({ type: constants.GO_TO_PAGE, page: '/community?eid=' + communityId })
      }
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.EDIT_COMMUNITY_ERROR, error: error })
    }
  }
}

export const deleteCommunity = (communityId: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.DELETE_COMMUNITY_TRY })
    const accessToken = getState().userReducer.token
    // const options = {
    //   method: 'Delete',
    //   body: JSON.stringify({}),
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Delete', {}, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.DELETE_COMMUNITY_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(BASE_DOMAIN + '/community/' + communityId, options)
      const response = await res.json()

      dispatch({
        type: constants.DELETE_COMMUNITY_RESPONSE,
        response: response,
        entryId: communityId,
      })

      if (response.success) {
        dispatch({ type: constants.GO_TO_PAGE, page: '/' })
      }
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.DELETE_COMMUNITY_ERROR, error: error })
    }
  }
}

const uploadImageToCommunity = async (imagePath: string, imageToUpload: any, dispatch: any,) => {
  dispatch({ type: constants.UPLOAD_COMMUNITY_IMAGE_TRY })
  const imageRef = storageRef(storage, imagePath)

  return await storageUploadBytes(imageRef, imageToUpload)
    .then((snapshot: any) => {
      dispatch({
        type: constants.UPLOAD_COMMUNITY_IMAGE_RESPONSE,
        response: snapshot,
      })
      return true
    })
    .catch((error) => {
      //  isDev && console.log(error)
      dispatch({ type: constants.UPLOAD_COMMUNITY_IMAGE_ERROR, error: error })
      return null
    })
}

const addDownloadImageToBackend = async (entryId: string, imageName: string, dispatch: any, accessToken: string,) => {
  dispatch({ type: constants.ADD_IMAGE_LINK_TO_SERVER_TRY })
  return async (dispatch: AppDispatch, getState: () => RootState) => {

    const imagePath = 'Communities/' + entryId + '/' + imageName
    const imageURL = await getDownloadLink(imagePath, dispatch)
    if (!imageURL) {
      //  isDev && console.log("Can't get download link")
      return
    }

    // const options = {
    //   method: 'Post',
    //   body: JSON.stringify({
    //     imageURL: imageURL,
    //     entryId: entryId,
    //     entryType: EntryType.COMMUNITY
    //   }),
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Post', {
      imageURL: imageURL,
      entryId: entryId,
      entryType: EntryType.COMMUNITY
    }, getState, dispatch)

    if (!options) {
      dispatch({ type: constants.ADD_IMAGE_LINK_TO_SERVER_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(`${BASE_DOMAIN}/community/${entryId}/addImage`, options)

      const response = await res.json()
      dispatch({
        type: constants.ADD_IMAGE_LINK_TO_SERVER_RESPONSE,
        response: response,
      })
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.ADD_IMAGE_LINK_TO_SERVER_ERROR, error: error })
    }
  }
}

export const getLatestCommunities = (country?: string, city?: string, isClearOldData?: boolean) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.GET_LATEST_COMMUNITIES_TRY })
    const accessToken = getState().userReducer.token
    const params = new URLSearchParams()
    if (country) params.append('country', country.trim())
    if (city) params.append('city', city.trim())

    const url = `/community?${params}`

    // const options = {
    //   method: 'Get',
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //   },
    // }

    const options = await optionsMaker('Get', null, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.GET_LATEST_COMMUNITIES_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(BASE_DOMAIN + url, options)
      const response = await res.json()
      if (isClearOldData && response.success && response.entries.length > 0) {
        await dispatch({
          type: constants.CLEAR_OLD_DATA,
          force: true,
          entryType: EntryType.COMMUNITY
        })
      }
      dispatch({
        type: constants.GET_LATEST_COMMUNITIES_RESPONSE,
        response,
      })
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.GET_LATEST_COMMUNITIES_ERROR, error: error })
    }
  }
}

export const getMyCommunities = () => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.GET_MY_COMMUNITIES_TRY })
    const accessToken = getState().userReducer.token
    const url = `/community`
    // const options = {
    //   method: 'Get',
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //   },
    // }

    const options = await optionsMaker('Get', null, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.GET_MY_COMMUNITIES_ERROR, error: "no options" })
      return
    }
    try {
      const response = await fetch(BASE_DOMAIN + url, options)
      dispatch({
        type: constants.GET_MY_COMMUNITIES_RESPONSE,
        response: await response.json(),
      })
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.GET_MY_COMMUNITIES_ERROR, error: error })
    }
  }
}

export const getCommunity = (communityId: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.GET_COMMUNITY_TRY })
    const accessToken = getState().userReducer.token

    const url = `/community/${communityId}`
    // const options = {
    //   method: 'Get',
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //   },
    // }

    const options = await optionsMaker('Get', null, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.GET_COMMUNITY_ERROR, error: "no options" })
      return
    }
    try {
      const response = await fetch(BASE_DOMAIN + url, options)
      dispatch({
        type: constants.GET_COMMUNITY_RESPONSE,
        response: await response.json(),
      })
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.GET_COMMUNITY_ERROR, error: error })
    }
  }
}

export const sendRatingToCommunity = (communityId: string, rating: number) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.SEND_RATING_TO_COMMUNITY_TRY })
    const accessToken = getState().userReducer.token

    // const options = {
    //   method: 'Post',
    //   body: JSON.stringify({
    //     rating: rating,
    //     entryId: communityId,
    //     entryType: EntryType.COMMUNITY
    //   }),
    //   headers: {
    //     Authorization: 'Bearer ' + accessToken,
    //     'Content-Type': 'application/json',
    //   },
    // }

    const options = await optionsMaker('Post', {
      rating: rating,
      entryId: communityId,
      entryType: EntryType.COMMUNITY
    }, getState, dispatch)

    if (!options) {
      dispatch({ type: constants.SEND_RATING_TO_COMMUNITY_ERROR, error: "no options" })
      return
    }

    try {
      const r = await fetch(BASE_DOMAIN + '/community/addRating', options)
      const response = await r.json()
      dispatch({
        type: constants.SEND_RATING_TO_COMMUNITY_RESPONSE,
        response: await response,
      })

      if (response.success) {
        dispatch(getCommunity(communityId))
        // dispatch({ type: constants.GO_TO_PAGE, page: '/community/?eid=' + communityId })
      }
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.SEND_RATING_TO_COMMUNITY_ERROR, error: error })
    }
  }
}

export const flagCommunity = (communityId: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.FLAG_COMMUNITY_TRY })

    const options = await optionsMaker('Post',
      {}
      , getState, dispatch)
    if (!options) {
      dispatch({ type: constants.FLAG_COMMUNITY_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(BASE_DOMAIN + '/community/' + communityId + '/flag', options)
      const response = await res.json()

      dispatch({
        type: constants.FLAG_COMMUNITY_RESPONSE,
        response: response,
      })

    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.FLAG_COMMUNITY_ERROR, error: error })
    }
  }
}

export const joinCommunity = (communityId: string, newState: boolean) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.JOIN_COMMUNITY_TRY })

    const options = await optionsMaker('Post', {
      newState
    }, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.JOIN_COMMUNITY_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(BASE_DOMAIN + '/community/' + communityId + '/join', options)
      const response = await res.json()
      const uid = getState().userReducer.user?.uid

      dispatch({
        type: constants.JOIN_COMMUNITY_RESPONSE,
        response: response,
        entryId: communityId,
        newState,
        uid

      })

    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.JOIN_COMMUNITY_ERROR, error: error })
    }
  }
}

export const removeUserFromCommunity = (communityId: string, uidToRemove: string) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch({ type: constants.REMOVE_USER_FROM_COMMUNITY_TRY })

    const options = await optionsMaker('Post', {
      entryType: EntryType.COMMUNITY,
      entryId: communityId,
      uidToRemove
    }, getState, dispatch)
    if (!options) {
      dispatch({ type: constants.REMOVE_USER_FROM_COMMUNITY_ERROR, error: "no options" })
      return
    }
    try {
      const res = await fetch(BASE_DOMAIN + '/community/removeUserFromCommunity', options)
      const response = await res.json()

      if (response.success) {
        dispatch(getCommunity(communityId))
      }

      dispatch({
        type: constants.REMOVE_USER_FROM_COMMUNITY_RESPONSE,
        response: response,
        entryId: communityId,
        uidToRemove,
      })
    } catch (error) {
      //  isDev && console.log(error)
      dispatch({ type: constants.REMOVE_USER_FROM_COMMUNITY_ERROR, error: error })
    }
  }
}